/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 22/11/21
 */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import StackFillIcon from 'remixicon-react/StackFillIcon';
import BookmarkMenu from './BookmarkMenu';
import ShowIncidencesAction from './ShowIncidencesAction';
import styles from './index.less';
import { BookmarkProvider } from './useBookmarkContext';

const Bookmarks = ({ contents, hideIncidences, onSelectedChange, children, scrollInTable }) => {
  const { t } = useTranslation('auditorAudits');

  const [visible, setVisible] = useState(false);
  const drawerRef = useRef();

  const showDrawer = useCallback(() => {
    setVisible(!visible);
  }, [visible]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setVisible(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <BookmarkProvider scrollInTable={ scrollInTable }>
      <div className={ classNames(styles.siteDrawerRenderInCurrentWrapper, 'flex flex-row w-full') }>
        <div className={ classNames(styles.wrapperSidebarBookMarkDrawer, 'w-full h-full') }>
          <div ref={ drawerRef } className="sidebar-drawer">
            <div className={ classNames(styles.bookMark, visible ? styles.bookMarkVisible : '') }>
              <div className={ styles.bookMarkBar } onClick={ showDrawer }>
                <span className="bookmark-navigation-text">{ t('audits.navigation') }</span>
                <StackFillIcon style={ { transform: 'rotate(180deg)', margin: '10px 0 0 0', padding: '2px' } } />
              </div>
              { !hideIncidences && <ShowIncidencesAction /> }
            </div>
            <div className={ classNames(styles.sidebarBookMarkDrawer, visible ? styles.animateSectionsDrawer : styles.hiddenSectionsDrawer) } id="sidebarBookMarkDrawer">
              <BookmarkMenu contents={ contents } onSelectedChange={ onSelectedChange } />
            </div>
          </div>
          { children }
        </div>
      </div>
    </BookmarkProvider>
  );
};

Bookmarks.propTypes = {
  contents: PropTypes.array,
  hideIncidences: PropTypes.bool,
  onSelectedChange: PropTypes.func,
  children: PropTypes.element,
  scrollInTable: PropTypes.bool
};

Bookmarks.defaultProps = {

};

export default memo(Bookmarks);
